import React from "react";
import Layout from "../layouts/GeneralLayout";
import SingleTrip from "../screens/Booking/SingleTrip";

const MobileSingleTripPage = () => {
  return (
    <Layout>
      <SingleTrip />
    </Layout>
  );
};

export default MobileSingleTripPage;
